import React from 'react';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { selectors } from './../ducks/related.duck';
import AlertSummary from 'containers/AlertSummary';
import SummaryList from 'components/general/SummaryList/SummaryList';
import MediaSkeleton from 'components/general/Media/MediaSkeleton';

const AlertRelated = compose(
  withProps({
    renderItem: props => (
      <AlertSummary
        {...props}
        small
        hide={['summary', 'image']}
      />
    ),
    renderSkeletonItem: () => (
      <MediaSkeleton image={false} />
    ),
  }),
  connect(state => {
    const items = selectors.data(state);
    return { items: Array.isArray(items) ? items : [], loading: selectors.loading(state) };
  }),
)(SummaryList);

export default AlertRelated;
